import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'
import AuditLogsView from './views/AuditLogsView.vue'
import CarriersView from './views/CarriersView.vue'
import ConfigView from './views/ConfigView.vue'
import GovAccountsView from './views/GovAccountsView.vue'
import LoginView from './views/LoginView.vue'
import OrderDetailView from './views/OrderDetailView.vue'
import OrdersView from './views/OrdersView.vue'
import PricingTablesView from './views/PricingTablesView.vue'
import SettlementsView from './views/SettlementsView.vue'
import { hasToken } from './api/client'

/**
 * 运营端路由。
 *
 * S-01 两条(承运商 / 计价表),S-10 加三条:登录、订单驾驶舱、平台配置,
 * S-11 加一条:监管端账号(开户与停用),S-43 加一条:结算与对账,
 * S-44 加一条:审计日志(画板 v2 · O3),S-47 加一条:订单详情(画板 v2 · O9)——
 * 每一页都是**建成时才加路由**:提前铺空页面是按层交付,菜单看起来齐了、点进去全是空的。
 *
 * 七条功能路由与 App.vue 的 NAV 逐项对应(顺序见 Y-32 的清单),
 * 两边由 guards/check-admin-nav.mjs 双向核对。**订单详情不带导航项**
 * (Y-32:详情类页面只有从列表点进来这一条路;它在守卫的 NO_NAV_VIEWS 里
 * 逐条写理由)——它不在上面那七条里,是 /orders 下面带参数的那一条。
 *
 * ═══ 没有令牌就跳登录页 ═══
 *
 * 这个前置守卫是**体验**,不是权限:S-01 起这个前端曾用硬编码的 'dev-ops-token'
 * 兜底,于是「没登录」表现成「打开了但每个请求都 401」。真正的权限在服务端
 * (OpsTokenGuard),这里只负责把没令牌的人送到登录页,并记住他原本要去哪。
 */
const routes: RouteRecordRaw[] = [
  { path: '/', redirect: '/orders' },
  { path: '/login', name: 'login', component: LoginView, meta: { public: true } },
  { path: '/orders', name: 'orders', component: OrdersView },
  // 订单详情(O9)。props: true —— orderNo 从路由参数直接进组件的 props,
  // 页面里不读 $route(换版/换参数源时只改这一行)
  { path: '/orders/:orderNo', name: 'order-detail', component: OrderDetailView, props: true },
  { path: '/settlements', name: 'settlements', component: SettlementsView },
  { path: '/audit-logs', name: 'audit-logs', component: AuditLogsView },
  { path: '/carriers', name: 'carriers', component: CarriersView },
  { path: '/pricing-tables', name: 'pricing-tables', component: PricingTablesView },
  { path: '/config', name: 'config', component: ConfigView },
  { path: '/gov-accounts', name: 'gov-accounts', component: GovAccountsView },
]

export const router = createRouter({
  history: createWebHistory(),
  routes,
})

router.beforeEach((to) => {
  if (to.meta.public) return true
  if (hasToken()) return true
  return { path: '/login', query: { redirect: to.fullPath } }
})
